import { render, staticRenderFns } from "./DateWiseReport.vue?vue&type=template&id=47807487&scoped=true&"
import script from "./DateWiseReport.vue?vue&type=script&lang=js&"
export * from "./DateWiseReport.vue?vue&type=script&lang=js&"
import style0 from "./DateWiseReport.vue?vue&type=style&index=0&id=47807487&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47807487",
  null
  
)

export default component.exports